import { mapGetters } from 'vuex';
import { initialDashboardState } from './dashboard/dashboardState';
import { dashboardComputed } from './dashboard/dashboardComputed';
import { dashboardLifecycle } from './dashboard/dashboardLifecycle';
import { dashboardMethodCorporateEmail } from './dashboard/dashboardMethodCorporateEmail';
import { dashboardMethodTiles } from './dashboard/dashboardMethodTiles';
import { dashboardMethodUIHelpers } from './dashboard/dashboardMethodUIHelpers';
import { dashboardMethodBooks } from './dashboard/dashboardMethodBooks';
import { dashboardMethodMainFunc } from './dashboard/dashboardMethodMainFunc';
import { dashboardMethodFavorites } from './dashboard/dashboardMethodFavorites';
import FavStar from './components/FavStar.vue';

export default {
    components: {
        FavStar,
    },
    data() {
        return initialDashboardState(this.$store) 
    },
computed:{
    ...mapGetters(['authenticated',
                'auth_token',
                'auth_user',
                'book_and_desc',
                'selected_book',
                'active_pages',
                'selected_page',
                'selected_book_desc',
                'active_tile',
                'vuexLoaderTrigger',
                'tiles_update',
                'tiles_new',
                'tiles_open_clear',
                'tiles_complete_clear',
                'web_only',
                'active_books',
                'newload',
                'tile_view_display',
                'theme',
                'favorite_tiles',
                'favorite_tile_ids'
    ]),
    ...dashboardComputed,
},
...dashboardLifecycle, // created, mounted, beforeDestroy

methods: {
    ...dashboardMethodCorporateEmail,
    ...dashboardMethodTiles,
    ...dashboardMethodUIHelpers,
    ...dashboardMethodBooks,
    ...dashboardMethodMainFunc,
    ...dashboardMethodFavorites,
},
}